const defaultState = {
  branches: []
};

export default defaultState;
